import "./style.css";
import React from "react";

import Container from "components/Container";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function Card({
	cardContainerClass,
	cardId,
	cardTitleContainerClass,
	cardTitleIconClass,
	cardTitleIcon,
	cardTitleClass,
	cardTitle,
	cardBodyClass,
	cardBody,
	cardInfoClass,
	cardInfo,
	children,
	onClickFunction
}) {

	return (
		<Container
			containerClass={`card-container ${cardContainerClass}`}
			containerId={cardId}
			onClick={onClickFunction}
		>
			{cardTitle ? (
				<Container
					containerClass={`card-title-container ${cardTitleContainerClass}`}
				>
					{cardTitleIcon ? (
						<FontAwesomeIcon
							icon={cardTitleIcon}
							className={`card-title-icon ${cardTitleIconClass}`}
						/>
					) : null}
					<p className={`card-title ${cardTitleClass}`}>
						{cardTitle}
					</p>
				</Container>
			) : null}
			<div className={`card-body ${cardBodyClass}`}>
				<p>{cardBody}</p>
				{children}
			</div>
			<p className={`card-info ${cardInfoClass}`}>{cardInfo}</p>
		</Container>
	);
}
